import React, { useContext, useState } from 'react';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Pagination } from '@wds/pagination';
import { Grid } from '@wds/grid';
import AppListingContext from './components/AppListingContext/AppListingContext';
import AppsGrid from './components/AppsGrid/AppsGrid';
import CategorySection from './components/CategorySection';
import { SearchContext } from '../../components/SearchContext';
import { FEATURED } from '../../components/SearchContext/constants';
import AppListingSort from './components/AppListingSort/AppListingSort';
import useStyles from './styles';
import NoResultsCard from './components/NoResultsCard';

const Listings = () => {
  const { featuredApps, results } = useStyles();
  const { search: searchTerm, pageNum, updatePageNum } = useContext(SearchContext);
  const { appListings, pageInfo, isInitialSearch, clearSearch } = useContext(AppListingContext);
  const [featuredParams, setFeaturedParams] = useState({ sortBy: FEATURED.value, page: 1, pageSize: 4 });

  const showAllFeatured = () => {
    setFeaturedParams({ sortBy: FEATURED.value, page: 1, pageSize: 12 });
  };

  const hideAllFeatured = () => {
    setFeaturedParams({ sortBy: FEATURED.value, page: 1, pageSize: 4 });
  };

  return (
    <Box mb={5}>
      <If condition={isInitialSearch}>
        <Box mb={5} className={featuredApps}>
          <CategorySection
            moreLink={showAllFeatured}
            moreLinkLabel="See all Featured"
            lessLink={hideAllFeatured}
            lessLinkLabel="See less Featured"
            queryParams={featuredParams}
            sectionName="Featured"
          />
        </Box>
      </If>
      <Box>
        <Box mb={4}>
          <Grid noBleeds noGutters>
            <Grid.Item>
              <Choose>
                <When condition={isInitialSearch}>
                  <Typography variant="sectionTitle" weight="medium">
                    All Apps
                  </Typography>
                </When>
                <Otherwise>
                  <Box display="flex" className={results}>
                    <Typography variant="sectionTitle" weight="medium">
                      Results
                    </Typography>
                    <Button color="link" variant="text" onClick={clearSearch}>
                      Clear filters
                    </Button>
                  </Box>
                </Otherwise>
              </Choose>
            </Grid.Item>
            <Grid.Item>
              <Box display="flex" justifyContent="flex-end">
                <AppListingSort />
              </Box>
            </Grid.Item>
          </Grid>
        </Box>
        <If condition={appListings.length > 0}>
          <AppsGrid apps={appListings} key="Search" />
          <Box mt={4}>
            <Pagination
              page={pageNum}
              count={pageInfo.total}
              rowsPerPage={pageInfo.perPage}
              onChangePage={(_, newPage) => {
                updatePageNum(newPage);
              }}
            />
          </Box>
        </If>
        <If condition={appListings.length === 0}>
          <NoResultsCard searchTerm={searchTerm} />
        </If>
      </Box>
    </Box>
  );
};

export default Listings;
